import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n          @media (min-width: ", "px) and (max-width: ", "px) {\n            ", "\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { breakpoints, sizes } from './breakpoints'; // Use px in breakpoints to work properly cross-browser and support users
// Styled-components reference: https://github.com/styled-components/styled-components/blob/master/packages/styled-components/docs/tips-and-tricks.md

var minCss = function minCss(px) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /* prettier-ignore */
    px === 0 ? css.apply(void 0, args) : css(_templateObject(), px, css.apply(void 0, args))
  );
};

var maxCss = function maxCss(px) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (
    /* prettier-ignore */
    px === Number.MAX_SAFE_INTEGER ? css.apply(void 0, args) : css(_templateObject2(), px, css.apply(void 0, args))
  );
};

var betweenCss = function betweenCss(minPx, maxPx) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return (
    /* prettier-ignore */
    minPx === 0 && maxPx === Number.MAX_SAFE_INTEGER ? css.apply(void 0, args) : minPx === 0 ? maxCss.apply(void 0, [maxPx].concat(args)) : maxPx === Number.MAX_SAFE_INTEGER ? minCss.apply(void 0, [minPx].concat(args)) : css(_templateObject3(), minPx, maxPx, css.apply(void 0, args))
  );
};

var from = function from(fromPx) {
  var fromFn = function fromFn() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return minCss.apply(void 0, [fromPx].concat(args));
  };

  fromFn.to = function (toPx) {
    return function () {
      for (var _len5 = arguments.length, css = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        css[_key5] = arguments[_key5];
      }

      return betweenCss.apply(void 0, [fromPx, toPx].concat(css));
    };
  };

  return fromFn;
};

var to = function to(toPx) {
  var toFn = function toFn() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return maxCss.apply(void 0, [toPx].concat(args));
  };

  toFn.from = function (fromPx) {
    return function () {
      for (var _len7 = arguments.length, css = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        css[_key7] = arguments[_key7];
      }

      return betweenCss.apply(void 0, [fromPx, toPx].concat(css));
    };
  };

  return toFn;
};

sizes.forEach(function (size) {
  var _breakpoints$size = breakpoints[size],
      min = _breakpoints$size.min,
      max = _breakpoints$size.max;

  var fromFn = function fromFn() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    return minCss.apply(void 0, [min].concat(args));
  };

  var toFn = function toFn() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    return maxCss.apply(void 0, [max].concat(args));
  };

  fromFn.to = {};
  toFn.from = {};
  sizes.forEach(function (size) {
    fromFn.to[size] = function () {
      for (var _len10 = arguments.length, css = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        css[_key10] = arguments[_key10];
      }

      return betweenCss.apply(void 0, [min, breakpoints[size].max].concat(css));
    };

    toFn.from[size] = function () {
      for (var _len11 = arguments.length, css = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        css[_key11] = arguments[_key11];
      }

      return betweenCss.apply(void 0, [breakpoints[size].min, max].concat(css));
    };
  });
  from[size] = fromFn;
  to[size] = toFn;
});

// iterate through the sizes and create a media template
var media = _objectSpread({
  // @ts-expect-error Way too complex `from` type to correctly create
  from: from,
  // @ts-expect-error Way too complex `to` type to correctly create
  to: to
}, ['above', 'below', 'only'].reduce(function (media, key) {
  media[key] = sizes.reduce(function (acc, size) {
    var _breakpoints$size2 = breakpoints[size],
        min = _breakpoints$size2.min,
        max = _breakpoints$size2.max;

    switch (key) {
      case 'above':
        if (size === 'xl') {
          return acc;
        }

        acc[size] = function () {
          for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            args[_key12] = arguments[_key12];
          }

          return minCss.apply(void 0, [max + 1].concat(args));
        };

        return acc;

      case 'only':
        acc[size] = function () {
          for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            args[_key13] = arguments[_key13];
          }

          return betweenCss.apply(void 0, [min, max].concat(args));
        };

        return acc;

      case 'below':
        if (size === 'xs') {
          return acc;
        }

        acc[size] = function () {
          for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
            args[_key14] = arguments[_key14];
          }

          return maxCss.apply(void 0, [min - 1].concat(args));
        };

        return acc;

      default:
        return acc;
    }
  }, {});
  return media;
}, {}));

export { media };
export default media;